import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Music } from "lucide-react";

// Coche les chansons préférées d'un patient dans la bibliothèque de l'admin.
export default function FavoriteSongsPicker({ getUrl, putUrl, initial, name }) {
  const [tracks, setTracks] = useState([]);
  const [ids, setIds] = useState(initial || []);
  const [dirty, setDirty] = useState(false);
  useEffect(() => {
    api.get("/music").then((r) => setTracks(r.data)).catch(() => {});
    if (getUrl) api.get(getUrl).then((r) => setIds(r.data.favorite_tracks)).catch(() => {});
  }, [getUrl]);
  if (!tracks.length) return null;
  const toggle = (id) => { setDirty(true); setIds((l) => (l.includes(id) ? l.filter((x) => x !== id) : [...l, id])); };
  const save = async () => {
    try { await api.put(putUrl, { track_ids: ids }); setDirty(false); toast.success("Chansons préférées enregistrées"); }
    catch { toast.error("Enregistrement impossible."); }
  };
  const themes = [...new Set(tracks.map((t) => t.theme || "Autres"))];
  return (
    <section className="rounded-3xl bg-white border border-border/60 p-6 mb-8" data-testid="favorite-songs-picker">
      <h3 className="font-serif-display text-2xl mb-1 flex items-center gap-2"><Music className="w-6 h-6 text-rose-500" /> Les chansons préférées de {name}</h3>
      <p className="text-gray-500 mb-4">Cochez les chansons qu'il ou elle aime : elles apparaîtront dans « Mes chansons » sur son écran.</p>
      {themes.map((th) => (
        <div key={th} className="mb-3">
          <p className="text-xs uppercase tracking-wide text-gray-400 mb-1">{th}</p>
          <div className="grid sm:grid-cols-2 gap-2">
            {tracks.filter((t) => (t.theme || "Autres") === th).map((t) => (
              <label key={t.id} className="flex items-center gap-2 text-gray-700 cursor-pointer">
                <Checkbox checked={ids.includes(t.id)} onCheckedChange={() => toggle(t.id)} data-testid={`favorite-song-${t.id}`} />
                <span className="truncate">{t.title}{t.artist && <span className="text-gray-400"> · {t.artist}</span>}</span>
              </label>
            ))}
          </div>
        </div>
      ))}
      <Button onClick={save} disabled={!dirty} className="rounded-full bg-emerald-700 hover:bg-emerald-800 mt-2" data-testid="favorite-songs-save">Enregistrer ({ids.length})</Button>
    </section>
  );
}
